<template lang="pug">
  .notification
    .notification__header
      .notification__title
        template(v-if="assemblyDateDiff >= 1") Завтра монтаж по заказу
        template(v-else) Сегодня монтаж по заказу
      .notification__date {{ hours }}
    .notification__body
      p.notification__content
        | У одного или нескольких заказов назначен монтаж на
        template(v-if="assemblyDateDiff >= 1") завтра
        template(v-else) сегодня
      router-link.notification__link(
        @click.native="emitClick"
        title="График монтажей"
        :to="{name: 'orders'}"
      ) График монтажей
</template>

<script>
import notification from '@/mixins/notification.mixin';
import { differenceInDays } from 'date-fns';

export default {
  name: 'OrderAssemblyComes',
  mixins: [notification],

  computed: {
    assemblyDateDiff() {
      if (this.payload.assemblyDate) {
        return differenceInDays(
          new Date(this.payload.assemblyDate.date),
          new Date(this.createdAt)
        );
      } else {
        return false;
      }
    }
  }
};
</script>
